import React from "react";
import { Box, Button, Card, CardContent, Container, Typography } from "@mui/material";
import { Logout as LogoutIcon, Security as SecurityIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useUserStore } from "../../store";
import TwoFactorAuthSection from "../settings/TwoFactorAuthSection";

/**
 * Full-screen stop shown instead of the app when an organization the user belongs to requires
 * two-factor authentication and the user has not set it up (user.mfa_setup_required). The
 * backend blocks the rest of the API until then (config.middleware.MfaRequiredMiddleware).
 * Reuses the normal setup flow; once the recovery codes are acknowledged the user is refetched
 * and the app opens.
 */
function MfaSetupGate() {
  const { t } = useTranslation();
  const { user, fetchUser } = useUserStore();

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 3, sm: 6 } }} data-testid="mfa-setup-gate">
      <Card variant="outlined">
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <SecurityIcon color="primary" sx={{ fontSize: 36 }} />
            <Typography variant="h6">{t("mfaGate.title")}</Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {t("mfaGate.body")}
          </Typography>
          <TwoFactorAuthSection user={user} t={t} onEnabled={fetchUser} />
        </CardContent>
      </Card>
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<LogoutIcon />}
          onClick={() => { window.location.href = "/accounts/logout/"; }}
        >
          {t("Log out")}
        </Button>
      </Box>
    </Container>
  );
}

export default MfaSetupGate;
